import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.PaymentProfilePicker.';

  public static readonly selectPaymentProfile = `${Id.prefix}selectPaymentProfile`;
  public static readonly close = `${Id.prefix}close`;
}

export class LangPaymentProfilePicker {
  private constructor() {}

  public static selectPaymentProfile(): string {
    return interpolate(Id.selectPaymentProfile);
  }
  public static close(): string {
    return interpolate(Id.close);
  }
}

export class PaymentProfilePickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.selectPaymentProfile,
      "Select a {{glossary 'payment-profile'}}",
      'Dialog title for selecting a payment profile'
    );
    register.add(Id.close, 'Close', 'Button label for closing the picker dialog');
  }
}
